"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kage_1 = require("../../kage");
var util_1 = require("../../util");
var _2d_1 = require("../../2d");
var cd_1 = require("./cd");
function selectPolygonsRect(polygons, x1, y1, x2, y2) {
    return polygons.array.filter(function (polygon) { return (polygon.array.every(function (_a) {
        var x = _a.x, y = _a.y;
        return x1 <= x && x <= x2 && y1 <= y && y <= y2;
    })); });
}
function dfDrawFont(font, polygons, _a) {
    var a1 = _a.a1, x1 = _a.x1, y1 = _a.y1, x2 = _a.x2, y2 = _a.y2, x3 = _a.x3, y3 = _a.y3, x4 = _a.x4, y4 = _a.y4, a2_100 = _a.a2_100, kirikuchiAdjustment = _a.kirikuchiAdjustment, tateAdjustment = _a.tateAdjustment, opt3 = _a.opt3, a3_100 = _a.a3_100, haneAdjustment = _a.haneAdjustment, urokoAdjustment = _a.urokoAdjustment, kakatoAdjustment = _a.kakatoAdjustment, mageAdjustment = _a.mageAdjustment;
    switch (a1 % 100) { // ... no need to divide
        case 0:
            if (a2_100 === 98 && kirikuchiAdjustment === 0 && tateAdjustment === 0 && opt3 === 0) {
                var dx = x1 + x2, dy = 0;
                for (var _i = 0, _b = selectPolygonsRect(polygons, x1, y1, x2, y2); _i < _b.length; _i++) {
                    var polygon = _b[_i];
                    polygon.scale(10).floor().reflectX().translate(dx * 10, dy * 10).scale(0.1);
                }
            }
            else if (a2_100 === 97 && kirikuchiAdjustment === 0 && tateAdjustment === 0 && opt3 === 0) {
                var dx = 0, dy = y1 + y2;
                for (var _c = 0, _d = selectPolygonsRect(polygons, x1, y1, x2, y2); _c < _d.length; _c++) {
                    var polygon = _d[_c];
                    polygon.scale(10).floor().reflectY().translate(dx * 10, dy * 10).scale(0.1);
                }
            }
            else if (a2_100 === 99 && kirikuchiAdjustment === 0 && tateAdjustment === 0 && opt3 === 0) {
                if (a3_100 === 1 && haneAdjustment === 0 && mageAdjustment === 0) {
                    var dx = x1 + y2, dy = y1 - x1;
                    for (var _e = 0, _f = selectPolygonsRect(polygons, x1, y1, x2, y2); _e < _f.length; _e++) {
                        var polygon = _f[_e];
                        // polygon.translate(-x1, -y2).rotate90().translate(x1, y1);
                        polygon.scale(10).floor().rotate90().translate(dx * 10, dy * 10).scale(0.1);
                    }
                }
                else if (a3_100 === 2 && haneAdjustment === 0 && mageAdjustment === 0) {
                    var dx = x1 + x2, dy = y1 + y2;
                    for (var _g = 0, _h = selectPolygonsRect(polygons, x1, y1, x2, y2); _g < _h.length; _g++) {
                        var polygon = _h[_g];
                        polygon.scale(10).floor().rotate180().translate(dx * 10, dy * 10).scale(0.1);
                    }
                }
                else if (a3_100 === 3 && haneAdjustment === 0 && mageAdjustment === 0) {
                    var dx = x1 - y1, dy = y2 + x1;
                    for (var _j = 0, _k = selectPolygonsRect(polygons, x1, y1, x2, y2); _j < _k.length; _j++) {
                        var polygon = _k[_j];
                        // polygon.translate(-x1, -y1).rotate270().translate(x1, y2);
                        polygon.scale(10).floor().rotate270().translate(dx * 10, dy * 10).scale(0.1);
                    }
                }
            }
            break;
        case 1: {
            if (a3_100 === 4) {
                var _l = (x1 === x2 && y1 === y2)
                    ? [0, font.kMage] // ?????
                    : util_1.normalize([x1 - x2, y1 - y2], font.kMage), dx1 = _l[0], dy1 = _l[1];
                var tx1 = x2 + dx1;
                var ty1 = y2 + dy1;
                cd_1.cdDrawLine(font, polygons, x1, y1, tx1, ty1, a2_100 + kirikuchiAdjustment * 100, 1, tateAdjustment + opt3 * 10, 0, 0, 0);
                cd_1.cdDrawCurve(font, polygons, tx1, ty1, x2, y2, x2 - font.kMage * (((font.kAdjustTateStep + 4) - tateAdjustment - opt3 * 10) / (font.kAdjustTateStep + 4)), y2, 1, 14, tateAdjustment, haneAdjustment, opt3, mageAdjustment);
            }
            else {
                cd_1.cdDrawLine(font, polygons, x1, y1, x2, y2, a2_100 + kirikuchiAdjustment * 100, a3_100, tateAdjustment + opt3 * 10, urokoAdjustment, kakatoAdjustment, mageAdjustment);
            }
            break;
        }
        case 2: {
            // case 12: // ... no need
            if (a3_100 === 4) {
                var _m = (x2 === x3)
                    ? [0, -font.kMage] // ?????
                    : (y2 === y3)
                        ? [-font.kMage, 0] // ?????
                        : util_1.normalize([x2 - x3, y2 - y3], font.kMage), dx1 = _m[0], dy1 = _m[1];
                var tx1 = x3 + dx1;
                var ty1 = y3 + dy1;
                cd_1.cdDrawCurve(font, polygons, x1, y1, x2, y2, tx1, ty1, a2_100 + kirikuchiAdjustment * 100, 0, tateAdjustment, 0, opt3, 0);
                cd_1.cdDrawCurve(font, polygons, tx1, ty1, x3, y3, x3 - font.kMage, y3, 2, 14, tateAdjustment, haneAdjustment, 0, mageAdjustment);
            }
            else {
                cd_1.cdDrawCurve(font, polygons, x1, y1, x2, y2, x3, y3, a2_100 + kirikuchiAdjustment * 100, (a3_100 === 5 && haneAdjustment === 0 && mageAdjustment === 0) ? 15 : a3_100, tateAdjustment, haneAdjustment, opt3, mageAdjustment);
            }
            break;
        }
        case 3: {
            var _o = (x1 === x2 && y1 === y2)
                ? [0, font.kMage] // ?????
                : util_1.normalize([x1 - x2, y1 - y2], font.kMage), dx1 = _o[0], dy1 = _o[1];
            var tx1 = x2 + dx1;
            var ty1 = y2 + dy1;
            var _p = (x2 === x3 && y2 === y3)
                ? [0, -font.kMage] // ?????
                : util_1.normalize([x3 - x2, y3 - y2], font.kMage), dx2 = _p[0], dy2 = _p[1];
            var tx2 = x2 + dx2;
            var ty2 = y2 + dy2;
            cd_1.cdDrawLine(font, polygons, x1, y1, tx1, ty1, a2_100 + kirikuchiAdjustment * 100, 1, tateAdjustment + opt3 * 10, 0, 0, 0);
            cd_1.cdDrawCurve(font, polygons, tx1, ty1, x2, y2, tx2, ty2, 1, 1, 0, 0, tateAdjustment + opt3 * 10, mageAdjustment);
            if (!(a3_100 === 5 && haneAdjustment === 0 && !((x2 < x3 && x3 - tx2 > 0) || (x2 > x3 && tx2 - x3 > 0)))) { // for closer position
                cd_1.cdDrawLine(font, polygons, tx2, ty2, x3, y3, 6, a3_100, mageAdjustment, urokoAdjustment, kakatoAdjustment, (a3_100 === 5 && haneAdjustment === 0) ? 0 : mageAdjustment); // bolder by force
            }
            break;
        }
        case 12: {
            cd_1.cdDrawCurve(font, polygons, x1, y1, x2, y2, x3, y3, a2_100 + kirikuchiAdjustment * 100, 1, tateAdjustment, 0, opt3, 0);
            cd_1.cdDrawLine(font, polygons, x3, y3, x4, y4, 6, a3_100, 0, urokoAdjustment, kakatoAdjustment, mageAdjustment);
            break;
        }
        case 4: {
            var rate = util_1.hypot(x3 - x2, y3 - y2) / 120 * 6;
            if (rate > 6) {
                rate = 6;
            }
            var _q = (x1 === x2 && y1 === y2)
                ? [0, font.kMage * rate] // ?????
                : util_1.normalize([x1 - x2, y1 - y2], font.kMage * rate), dx1 = _q[0], dy1 = _q[1];
            var tx1 = x2 + dx1;
            var ty1 = y2 + dy1;
            var _r = (x2 === x3 && y2 === y3)
                ? [0, -font.kMage * rate] // ?????
                : util_1.normalize([x3 - x2, y3 - y2], font.kMage * rate), dx2 = _r[0], dy2 = _r[1];
            var tx2 = x2 + dx2;
            var ty2 = y2 + dy2;
            cd_1.cdDrawLine(font, polygons, x1, y1, tx1, ty1, a2_100 + kirikuchiAdjustment * 100, 1, tateAdjustment + opt3 * 10, 0, 0, 0);
            cd_1.cdDrawCurve(font, polygons, tx1, ty1, x2, y2, tx2, ty2, 1, 1, 0, 0, 0, 0);
            if (!(a3_100 === 5 && haneAdjustment === 0 && mageAdjustment === 0 && x3 - tx2 <= 0)) { // for closer position
                cd_1.cdDrawLine(font, polygons, tx2, ty2, x3, y3, 6, a3_100, 0, urokoAdjustment, kakatoAdjustment, mageAdjustment); // bolder by force
            }
            break;
        }
        case 6: {
            if (a3_100 === 4) {
                var _s = (x3 === x4)
                    ? [0, -font.kMage] // ?????
                    : (y3 === y4)
                        ? [-font.kMage, 0] // ?????
                        : util_1.normalize([x3 - x4, y3 - y4], font.kMage), dx1 = _s[0], dy1 = _s[1];
                var tx1 = x4 + dx1;
                var ty1 = y4 + dy1;
                cd_1.cdDrawBezier(font, polygons, x1, y1, x2, y2, x3, y3, tx1, ty1, a2_100 + kirikuchiAdjustment * 100, 1, tateAdjustment, 0, opt3, 0);
                cd_1.cdDrawCurve(font, polygons, tx1, ty1, x4, y4, x4 - font.kMage, y4, 1, 14, 0, haneAdjustment, 0, mageAdjustment);
            }
            else {
                cd_1.cdDrawBezier(font, polygons, x1, y1, x2, y2, x3, y3, x4, y4, a2_100 + kirikuchiAdjustment * 100, (a3_100 === 5 && haneAdjustment === 0 && mageAdjustment === 0) ? 15 : a3_100, tateAdjustment, haneAdjustment, opt3, mageAdjustment);
            }
            break;
        }
        case 7: {
            cd_1.cdDrawLine(font, polygons, x1, y1, x2, y2, a2_100 + kirikuchiAdjustment * 100, 1, tateAdjustment + opt3 * 10, 0, 0, 0);
            cd_1.cdDrawCurve(font, polygons, x2, y2, x3, y3, x4, y4, 1, a3_100, tateAdjustment, haneAdjustment, opt3, mageAdjustment);
            break;
        }
        case 9: // may not be exist ... no need
            // kageCanvas[y1][x1] = 0;
            // kageCanvas[y2][x2] = 0;
            break;
        default:
            break;
    }
}
var Mincho = /** @class */ (function () {
    function Mincho() {
        this.shotai = kage_1.KShotai.kMincho;
        this.kRate = 100; // must divide 1000
        this.setSize();
    }
    Mincho.prototype.draw = function (polygons, stroke) {
        dfDrawFont(this, polygons, stroke);
    };
    Mincho.prototype.setSize = function (size) {
        if (size === 1) {
            this.kMinWidthY = 1.2;
            this.kMinWidthT = 3.6;
            this.kWidth = 3;
            this.kKakato = 1.8;
            this.kL2RDfatten = 1.1;
            this.kMage = 6;
            this.kUseCurve = false;
            this.kAdjustKakatoL = [8, 5, 3, 1, 0];
            this.kAdjustKakatoR = [4, 3, 2, 1];
            this.kAdjustKakatoRangeX = 12;
            this.kAdjustKakatoRangeY = [1, 11, 14, 18];
            this.kAdjustKakatoStep = 3;
            this.kAdjustUrokoX = [14, 12, 9, 7];
            this.kAdjustUrokoY = [7, 6, 5, 4];
            this.kAdjustUrokoLength = [13, 21, 30];
            this.kAdjustUrokoLengthStep = 3;
            this.kAdjustUrokoLine = [13, 15, 18];
        }
        else {
            this.kMinWidthY = 2;
            this.kMinWidthU = 2;
            this.kMinWidthT = 6;
            this.kWidth = 5;
            this.kKakato = 3;
            this.kL2RDfatten = 1.1;
            this.kMage = 10;
            this.kUseCurve = false;
            this.kAdjustKakatoL = [14, 9, 5, 2, 0];
            this.kAdjustKakatoR = [8, 6, 4, 2];
            this.kAdjustKakatoRangeX = 20;
            this.kAdjustKakatoRangeY = [1, 19, 24, 30];
            this.kAdjustKakatoStep = 3;
            this.kAdjustUrokoX = [24, 20, 16, 12];
            this.kAdjustUrokoY = [12, 11, 9, 8];
            this.kAdjustUrokoLength = [22, 36, 50];
            this.kAdjustUrokoLengthStep = 3;
            this.kAdjustUrokoLine = [22, 26, 30];
            this.kAdjustUroko2Step = 3;
            this.kAdjustUroko2Length = 40;
            this.kAdjustTateStep = 4;
            this.kAdjustMageStep = 5;
        }
    };
    Mincho.prototype.adjustStrokes = function (strokesArray) {
        this.adjustHane(strokesArray);
        this.adjustMage(strokesArray);
        this.adjustTate(strokesArray);
        this.adjustKakato(strokesArray);
        this.adjustUroko(strokesArray);
        this.adjustUroko2(strokesArray);
        this.adjustKirikuchi(strokesArray);
        return strokesArray;
    };
    Mincho.prototype.adjustHane = function (strokesArray) {
        strokesArray.forEach(function (stroke, i) {
            if ((stroke.a1 === 1 || stroke.a1 === 2 || stroke.a1 === 6)
                && stroke.a3_100 === 4 && stroke.haneAdjustment === 0 && stroke.mageAdjustment === 0) {
                var lpx_1; // lastPointX
                var lpy_1; // lastPointY
                if (stroke.a1 === 1) {
                    lpx_1 = stroke.x2;
                    lpy_1 = stroke.y2;
                }
                else if (stroke.a1 === 2) {
                    lpx_1 = stroke.x3;
                    lpy_1 = stroke.y3;
                }
                else {
                    lpx_1 = stroke.x4;
                    lpy_1 = stroke.y4;
                }
                var mn_1 = Infinity; // mostNear
                if (lpx_1 + 18 < 100) {
                    mn_1 = lpx_1 + 18;
                }
                strokesArray.forEach(function (stroke2, j) {
                    if (i !== j
                        && stroke2.a1 === 1
                        && stroke2.x1 === stroke2.x2 && stroke2.x1 < lpx_1
                        && stroke2.y1 <= lpy_1 && stroke2.y2 >= lpy_1) {
                        if (lpx_1 - stroke2.x1 < 100) {
                            mn_1 = Math.min(mn_1, lpx_1 - stroke2.x1);
                        }
                    }
                });
                if (mn_1 !== Infinity) {
                    stroke.haneAdjustment += 7 - Math.floor(mn_1 / 15);
                }
            }
        });
        return strokesArray;
    };
    Mincho.prototype.adjustMage = function (strokesArray) {
        var _this = this;
        strokesArray.forEach(function (stroke, i) {
            if (stroke.a1 === 3 && stroke.y2 === stroke.y3) {
                strokesArray.forEach(function (stroke2, j) {
                    if (i !== j && ((stroke2.a1 === 1
                        && stroke2.y1 === stroke2.y2
                        && !(stroke.x2 + 1 > stroke2.x2 || stroke.x3 - 1 < stroke2.x1)
                        && util_1.round(Math.abs(stroke.y2 - stroke2.y1)) < _this.kMinWidthT * _this.kAdjustMageStep) || (stroke2.a1 === 3
                        && stroke2.y2 === stroke2.y3
                        && !(stroke.x2 + 1 > stroke2.x3 || stroke.x3 - 1 < stroke2.x2)
                        && util_1.round(Math.abs(stroke.y2 - stroke2.y2)) < _this.kMinWidthT * _this.kAdjustMageStep))) {
                        stroke.mageAdjustment += _this.kAdjustMageStep - Math.floor(Math.abs(stroke.y2 - stroke2.y2) / _this.kMinWidthT);
                        if (stroke.mageAdjustment > _this.kAdjustMageStep) {
                            stroke.mageAdjustment = _this.kAdjustMageStep;
                        }
                    }
                });
            }
        });
        return strokesArray;
    };
    Mincho.prototype.adjustTate = function (strokesArray) {
        var _this = this;
        strokesArray.forEach(function (stroke, i) {
            if ((stroke.a1 === 1 || stroke.a1 === 3 || stroke.a1 === 7)
                && stroke.x1 === stroke.x2) {
                strokesArray.forEach(function (stroke2, j) {
                    if (i !== j
                        && (stroke2.a1 === 1 || stroke2.a1 === 3 || stroke2.a1 === 7)
                        && stroke2.x1 === stroke2.x2
                        && !(stroke.y1 + 1 > stroke2.y2 || stroke.y2 - 1 < stroke2.y1)
                        && util_1.round(Math.abs(stroke.x1 - stroke2.x1)) < _this.kMinWidthT * _this.kAdjustTateStep) {
                        stroke.tateAdjustment += _this.kAdjustTateStep - Math.floor(Math.abs(stroke.x1 - stroke2.x1) / _this.kMinWidthT);
                        if (stroke.tateAdjustment > _this.kAdjustTateStep) {
                            stroke.tateAdjustment = _this.kAdjustTateStep;
                        }
                    }
                });
            }
        });
        return strokesArray;
    };
    Mincho.prototype.adjustKakato = function (strokesArray) {
        var _this = this;
        strokesArray.forEach(function (stroke, i) {
            if (stroke.a1 === 1
                && (stroke.a3_100 === 13 || stroke.a3_100 === 23) && stroke.kakatoAdjustment === 0 && stroke.mageAdjustment === 0) {
                for (var k = 0; k < _this.kAdjustKakatoStep; k++) {
                    if (_2d_1.isCrossBoxWithOthers(strokesArray, i, stroke.x2 - _this.kAdjustKakatoRangeX / 2, stroke.y2 + _this.kAdjustKakatoRangeY[k], stroke.x2 + _this.kAdjustKakatoRangeX / 2, stroke.y2 + _this.kAdjustKakatoRangeY[k + 1])
                        || util_1.round(stroke.y2 + _this.kAdjustKakatoRangeY[k + 1]) > 200 // adjust for baseline
                        || util_1.round(stroke.y2 - stroke.y1) < _this.kAdjustKakatoRangeY[k + 1] // for thin box
                    ) {
                        stroke.kakatoAdjustment = 3 - k;
                        break;
                    }
                }
            }
        });
        return strokesArray;
    };
    Mincho.prototype.adjustUroko = function (strokesArray) {
        var _this = this;
        strokesArray.forEach(function (stroke, i) {
            if (stroke.a1 === 1
                && stroke.a3_100 === 0 && stroke.urokoAdjustment === 0 && stroke.mageAdjustment === 0) { // no operation for TATE
                for (var k = 0; k < _this.kAdjustUrokoLengthStep; k++) {
                    var tx = void 0;
                    var ty = void 0;
                    var tlen = void 0;
                    if (stroke.y1 === stroke.y2) { // YOKO
                        tx = stroke.x2 - _this.kAdjustUrokoLine[k];
                        ty = stroke.y2 - 0.5;
                        tlen = stroke.x2 - stroke.x1; // should be Math.abs(...)?
                    }
                    else {
                        var _a = (stroke.x1 === stroke.x2)
                            ? [0, (stroke.y2 - stroke.y1) / (stroke.x2 - stroke.x1) > 0 ? 1 : -1] // maybe unnecessary?
                            : (stroke.x2 - stroke.x1 < 0)
                                ? util_1.normalize([stroke.x1 - stroke.x2, stroke.y1 - stroke.y2]) // for backward compatibility...
                                : util_1.normalize([stroke.x2 - stroke.x1, stroke.y2 - stroke.y1]), cosrad = _a[0], sinrad = _a[1];
                        tx = stroke.x2 - _this.kAdjustUrokoLine[k] * cosrad - 0.5 * sinrad;
                        ty = stroke.y2 - _this.kAdjustUrokoLine[k] * sinrad - 0.5 * cosrad;
                        tlen = util_1.hypot(stroke.y2 - stroke.y1, stroke.x2 - stroke.x1);
                    }
                    if (util_1.round(tlen) < _this.kAdjustUrokoLength[k]
                        || _2d_1.isCrossWithOthers(strokesArray, i, tx, ty, stroke.x2, stroke.y2)) {
                        stroke.urokoAdjustment = _this.kAdjustUrokoLengthStep - k;
                        break;
                    }
                }
            }
        });
        return strokesArray;
    };
    Mincho.prototype.adjustUroko2 = function (strokesArray) {
        var _this = this;
        strokesArray.forEach(function (stroke, i) {
            if (stroke.a1 === 1 && stroke.a3_100 === 0 && stroke.urokoAdjustment === 0 && stroke.mageAdjustment === 0
                && stroke.y1 === stroke.y2) {
                var pressure_1 = 0;
                strokesArray.forEach(function (stroke2, j) {
                    if (i !== j && ((stroke2.a1 === 1
                        && stroke2.y1 === stroke2.y2
                        && !(stroke.x1 + 1 > stroke2.x2 || stroke.x2 - 1 < stroke2.x1)
                        && util_1.round(Math.abs(stroke.y1 - stroke2.y1)) < _this.kAdjustUroko2Length) || (stroke2.a1 === 3
                        && stroke2.y2 === stroke2.y3
                        && !(stroke.x1 + 1 > stroke2.x3 || stroke.x2 - 1 < stroke2.x2)
                        && util_1.round(Math.abs(stroke.y1 - stroke2.y2)) < _this.kAdjustUroko2Length))) {
                        pressure_1 += Math.pow((_this.kAdjustUroko2Length - Math.abs(stroke.y1 - stroke2.y2)), 1.1);
                    }
                });
                // const result = Math.min(Math.floor(pressure / this.kAdjustUroko2Length), this.kAdjustUroko2Step) * 100;
                // if (stroke.a3 < result) {
                stroke.urokoAdjustment = Math.min(Math.floor(pressure_1 / _this.kAdjustUroko2Length), _this.kAdjustUroko2Step);
                // }
            }
        });
        return strokesArray;
    };
    Mincho.prototype.adjustKirikuchi = function (strokesArray) {
        strokesArray.forEach(function (stroke) {
            if (stroke.a1 === 2
                && stroke.a2_100 === 32 && stroke.kirikuchiAdjustment === 0 && stroke.tateAdjustment === 0 && stroke.opt3 === 0
                && stroke.x1 > stroke.x2 && stroke.y1 < stroke.y2) {
                for (var _i = 0, strokesArray_1 = strokesArray; _i < strokesArray_1.length; _i++) { // no need to skip when i == j
                    var stroke2 = strokesArray_1[_i];
                    if (stroke2.a1 === 1
                        && stroke2.x1 < stroke.x1 && stroke2.x2 > stroke.x1 && stroke2.y1 === stroke.y1
                        && stroke2.y1 === stroke2.y2) {
                        stroke.kirikuchiAdjustment = 1;
                        break;
                    }
                }
            }
        });
        return strokesArray;
    };
    return Mincho;
}());
exports.default = Mincho;
